import { render, staticRenderFns } from "./sip.vue?vue&type=template&id=d172b704"
import script from "./sip.vue?vue&type=script&lang=js"
export * from "./sip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports